import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const OpenSvg = ()=>/*#__PURE__*/ _jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "16",
        viewBox: "0 0 16 16",
        fill: "none",
        "aria-hidden": "true",
        children: [
            /*#__PURE__*/ _jsx("path", {
                d: "M10.0117 1.99988C9.69688 1.99988 9.44166 2.25708 9.44166 2.57435C9.44166 2.89162 9.69688 3.14881 10.0117 3.14881H11.7172L8.58942 6.5226C8.37449 6.75443 8.38675 7.11795 8.6168 7.33455C8.84685 7.55114 9.20758 7.53878 9.42251 7.30695L12.4596 4.03097V5.82966C12.4596 6.14693 12.7148 6.40413 13.0296 6.40413C13.3445 6.40413 13.5997 6.14693 13.5997 5.82966V2.59057C13.6041 2.43164 13.5434 2.27164 13.419 2.15457C13.3092 2.05118 13.1696 1.99996 13.0303 1.99988L10.0117 1.99988Z",
                fill: "#676879"
            }),
            /*#__PURE__*/ _jsx("path", {
                d: "M7.41039 9.47716C7.62532 9.24533 7.61306 8.8818 7.38301 8.66521C7.15295 8.44862 6.79222 8.46097 6.5773 8.69281L3.54 11.969V10.17C3.54 9.85269 3.28478 9.5955 2.96995 9.5955C2.65512 9.5955 2.3999 9.85269 2.3999 10.17V13.4253C2.3999 13.492 2.41119 13.5561 2.43196 13.6157C2.46142 13.7005 2.51112 13.7796 2.58079 13.8452C2.69384 13.9516 2.83845 14.0028 2.9818 13.9998H5.98787C6.3027 13.9998 6.55792 13.7426 6.55792 13.4253C6.55792 13.108 6.3027 12.8508 5.98787 12.8508H4.28277L7.41039 9.47716Z",
                fill: "#676879"
            })
        ]
    });
export default OpenSvg;
